import type { FaireProductEntity } from "../../entity_types/product";

export const p_9b7xyqnrs8: FaireProductEntity = {
  token: "p_9b7xyqnrs8",
  type: "product",
  name: "CHUZA | Dried Pineapple | Chili-Seasoned Tropical Snack",
  brandName: "CHUZA",
  imageUrl:
    "https://cdn.faire.com/fastly/70f6d550d4b6bb641592f9f26413daeddae6f98468ee772e06fc2a4d50908dbc.png",
  priceDollars: 3.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a7c554df32cd889258c65e4ac3b54284c07955fc0741bd8f4d256d34fa2570af.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
